export default __webpack_public_path__ + "static/media/Captain's Vambraces of the Eastern Sun.ddef108f.jpg";